/** Strip empty values and serialize Date attributes to ISO strings for WebEngage. */
export const cleanWebEngageEventData = (data) => {
    const clean = (obj) => {
        if (obj instanceof Date) {
            return Number.isNaN(obj.getTime()) ? undefined : obj.toISOString();
        }
        if (Array.isArray(obj)) {
            return obj.map(clean).filter((v) => v !== null && v !== undefined);
        }
        if (typeof obj === "object" && obj !== null) {
            return Object.fromEntries(Object.entries(obj)
                .map(([key, value]) => [key, clean(value)])
                .filter(([_, value]) => value !== null &&
                value !== undefined &&
                !(typeof value === "string" && value.trim() === "") &&
                !(Array.isArray(value) && value.length === 0) &&
                !(typeof value === "object" &&
                    !Array.isArray(value) &&
                    Object.keys(value).length === 0)));
        }
        return obj;
    };
    return clean(data);
};
